module.exports = __webpack_public_path__ + "static/img/img7.1503a38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/simulator/img7.png
// module id = WCmP
// module chunks = 1